const GET_JOB_TREEVIEW_SUCCESS = "GET_JOB_TREEVIEW_SUCCESS";
const RESET_JOB_TREEVIEW = "RESET_JOB_TREEVIEW";
const POST_JOBS_SUCCESS = "POST_JOBS_SUCCESS";
const POST_JOBS_FAIL = "POST_JOBS_FAIL";
const POST_JOBS_LOADMORE_SUCCESS = "POST_JOBS_LOADMORE_SUCCESS";
const POST_JOBS_LOADMORE_FAIL = "POST_JOBS_LOADMORE_FAIL";
const POST_JOB_SUCCESS = "POST_JOB_SUCCESS";
const POST_JOB_FAIL = "POST_JOB_FAIL";
const JOB_METADATA_STANDARDS_SUCCESS = "JOB_METADATA_STANDARDS_SUCCESS";
const JOB_METADATA_STANDARDS_FAIL = "JOB_METADATA_STANDARDS_FAIL";
const JOB_METADATA_STANDARDS_CUSTOM_SUCCESS =
  "JOB_METADATA_STANDARDS_CUSTOM_SUCCESS";
const JOB_METADATA_STANDARDS_CUSTOM_FAIL = "JOB_METADATA_STANDARDS_CUSTOM_FAIL";
const JOB_SAVE_SUCCESS = "JOB_SAVE_SUCCESS";
const JOB_SAVE_FAIL = "JOB_SAVE_FAIL";
const JOB_EDIT_SUCCESS = "JOB_EDIT_SUCCESS";
const JOB_EDIT_FAIL = "JOB_EDIT_FAIL";
const JOB_UPDATE_SUCCESS = "JOB_UPDATE_SUCCESS";
const JOB_UPDATE_FAIL = "JOB_UPDATE_FAIL";
const JOB_EDIT_RESET = "JOB_EDIT_RESET";
const GET_DEVICES_SUCCESS = "GET_DEVICES_SUCCESS";
const GET_DEVICES_FAIL = "GET_DEVICES_FAIL";
const JOB_DELETE_SUCCESS = "JOB_DELETE_SUCCESS";
const JOB_DELETE_FAIL = "JOB_DELETE_FAIL";
const SET_PREV_SELETED_DEVICEID = "SET_PREV_SELETED_DEVICEID";
const RESET_JOB_FORM = "RESET_JOB_FORM";
const GET_FILTERED_JOBS_SUCCESS = "GET_FILTERED_JOBS_SUCCESS";
const GET_FILTERED_JOBS_FAIL = "GET_FILTERED_JOBS_FAIL";
const JOB_UPDATE_SYNC_SUCCESS = "JOB_UPDATE_SYNC_SUCCESS";
const JOB_UPDATE_SYNC_FAIL = "JOB_UPDATE_SYNC_FAIL";
const JOB_RELOAD_SUCCESS = "JOB_RELOAD_SUCCESS";
const JOB_RELOAD_FAILURE = "JOB_RELOAD_FAILURE";
const ADD_CUSTOMER_DEATILS_IN_BREADCRUM = "ADD_CUSTOMER_DEATILS_IN_BREADCRUM";
const ADD_CUSTOMER_DETAILS_WITH_NAME_IN_BREADCRUM =
  "ADD_CUSTOMER_DETAILS_WITH_NAME_IN_BREADCRUM";
const RESET_JOB_LIST = "RESET_JOB_LIST";
const JOBS_DEFAULT_ORDER = "JOBS_DEFAULT_ORDER";
const DELETED_JOB_LIST_SUCCESS = "DELETED_JOB_LIST_SUCCESS";
const PREVIOUS_SELECTED_ROW = "PREVIOUS_SELECTED_ROW";
const RESET_CLEAR_SAVED_FORM_SUCCESS = "RESET_CLEAR_SAVED_FORM_SUCCESS";
const RESET_CLEAR_SAVED_FORM_FAIL = "RESET_CLEAR_SAVED_FORM_FAIL";
const TEST_ID_UPLOAD_FILE_SUCCESS = "TEST_ID_UPLOAD_FILE_SUCCESS";
const TEST_ID_UPLOAD_FILE_FAIL = "TEST_ID_UPLOAD_FILE_FAIL";
const CLEAR_IMPORT_ERRORS_VALUES = "CLEAR_IMPORT_ERRORS_VALUES";
const JOB_MODIFIED = "JOB_MODIFIED";

export const defaultJobState = {
  jobs: null,
  job: null,
  standards: null,
  prevSelectedDeviceid: null,
  edit: null,
  form: null,
  filteredJobs: null,
  jobsDefaultOrder: { 
    name: "Date: New to old",
    field: "createdat",
    sorttype: "desc"
  },
  previousRow: null,
  jobTreeview: null,
  modifiedJobId: -1,
};

export default (state = defaultJobState, action) => {
  switch (action.type) {
    case POST_JOBS_SUCCESS:
      const s = { ...state };
      s.jobs = {};
      return {
        ...s,
        jobs: action.payload.data
      };
    case POST_JOBS_FAIL:
      return {
        ...state
      };
    case POST_JOBS_LOADMORE_SUCCESS: {
      const s = { ...state };
      s.jobs = {
        columns: s.columns,
        data: [...s.jobs.data, ...action.payload.data.data],
        pagecount: action.payload.data.pagecount,
        recordstotal: action.payload.data.recordstotal,
        recordsfiltered:
          action.payload.data.recordsfiltered + s.jobs.recordsfiltered
      };
      return {
        ...s
      };
    }
    case POST_JOBS_LOADMORE_FAIL:
      return {
        ...state
      };
    case POST_JOB_SUCCESS:
      return {
        ...state,
        job: action.payload.data
      };
    case POST_JOB_FAIL:
      return {
        ...state
      };
    case GET_JOB_TREEVIEW_SUCCESS:
      return {
        ...state,
        jobTreeview: action.payload.data
      };
    case RESET_JOB_TREEVIEW:
      return {
        ...state,
        jobTreeview: null
      };
    case JOB_METADATA_STANDARDS_SUCCESS:
      return {
        ...state,
        standards: action.payload.data
      };
    case JOB_METADATA_STANDARDS_FAIL:
      return {
        ...state
      };
    case GET_DEVICES_SUCCESS:
      return {
        ...state,
        devices: action.payload.data
      };
    case GET_DEVICES_FAIL:
      return {
        ...state
      };

    case JOB_METADATA_STANDARDS_CUSTOM_SUCCESS:
      return {
        ...state,
        custom: action.payload.data
      };
    case JOB_METADATA_STANDARDS_CUSTOM_FAIL:
      return {
        ...state
      };
    case JOB_SAVE_SUCCESS:
      return {
        ...state,
        form: action.payload.data.success
          ? action.meta.previousAction.payload.request.data.request
          : null
      };
    case JOB_SAVE_FAIL:
      return {
        ...state,
        form: null
      };

    case RESET_JOB_FORM:
      return {
        ...state,
        job: null,
        form: null
      };
    case JOB_EDIT_SUCCESS:
      return {
        ...state,
        edit: action.payload.data
      };
    case JOB_EDIT_FAIL:
      return {
        ...state
      };
    case JOB_UPDATE_SUCCESS:
      return {
        ...state,
        edit: action.payload.data.success ? null : state.edit,
        form: action.payload.data.success
          ? action.meta.previousAction.payload.request.data.request
          : null
      };
    case JOB_UPDATE_FAIL:
      return {
        ...state,
        edit: null
      };
    case JOB_EDIT_RESET:
      return {
        ...state,
        edit: null
      };
    case JOB_DELETE_SUCCESS:
      return {
        ...state
      };
    case JOB_DELETE_FAIL:
      return {
        ...state
      };
    case SET_PREV_SELETED_DEVICEID:
      return {
        ...state,
        prevSelectedDeviceid: action.payload
      };
    case GET_FILTERED_JOBS_SUCCESS:
      return {
        ...state,
        filteredJobs: action.payload.data
      };
    case GET_FILTERED_JOBS_FAIL:
      return {
        ...state
      };
    case JOB_UPDATE_SYNC_SUCCESS:
    case JOB_UPDATE_SYNC_FAIL:
      return {
        ...state
      };
    case JOB_RELOAD_SUCCESS: {
      let { jobs } = state;
      const data = jobs.data.map(job => {
        if (job.id === action.payload.data.id) {
          return {
            ...job,
            ...action.payload.data
          };
        }
        return job;
      });
      return {
        ...state,
        jobs: {
          ...jobs,
          data: data
        }
      };
    }
    case JOB_RELOAD_FAILURE:
      return {
        ...state
      };
    case ADD_CUSTOMER_DEATILS_IN_BREADCRUM: {
      return {
        ...state,
        customerNameDisplayed: action.data.isNameDisplayed,
        selectedCustomerId: action.data.cId
      };
    }
    case ADD_CUSTOMER_DETAILS_WITH_NAME_IN_BREADCRUM: {
      return {
        ...state,
        customerNameDisplayed: action.data.isNameDisplayed,
        selectedCustomerId: action.data.cId,
        selectedCustomerName: action.data.cName
      };
    }
    case RESET_JOB_LIST: {
      return {
        ...state,
        jobs: null
      };
    }
    case JOBS_DEFAULT_ORDER: {
      return {
        ...state,
        jobsDefaultOrder: action.payload
      };
    }
    case DELETED_JOB_LIST_SUCCESS: {
      return {
        ...state,
        deletedJobs: action.payload.data
      };
    }
    case RESET_CLEAR_SAVED_FORM_SUCCESS: {
      return {
        ...state,
        form: null
      };
    }
    case RESET_CLEAR_SAVED_FORM_FAIL: {
      return {
        ...state,
        form: null
      };
    }
    case PREVIOUS_SELECTED_ROW: {
      return {
        ...state,
        previousRow: action.payload
      };
    }
    case PREVIOUS_SELECTED_ROW: {
      return {
        ...state,
        previousRow: action.payload
      };
    }
    case TEST_ID_UPLOAD_FILE_SUCCESS: {
      return {
        ...state,
        testNameList: action.payload.data.names,
        IDerrors: action.payload.data.errors
      };
    }
    case TEST_ID_UPLOAD_FILE_FAIL: {
      return {
        ...state,
        testNameList: null
      };
    }
    case CLEAR_IMPORT_ERRORS_VALUES: {
      return {
        ...state,
        IDerrors: null
      };
    }

    case JOB_MODIFIED: {
      return {
        ...state,
        modifiedJobId: action.payload.data.jobId
      };

    }
    default:
      return state;
  }
};
